<review-display [review]="review">
  <strong>Author:</strong> {{review.authorFirstName}} {{review.authorLastName}} - <a href="mailto:{{review.authorEmail}}">{{review.authorEmail}}</a>
  <br/>
  @if (review.visitedFrom !== review.visitedTo) {
    <div><strong>Visited:</strong> {{review.visitedFrom | date}} - {{review.visitedTo | date}}</div>
  }
  @if (review.visitedFrom === review.visitedTo) {
    <div><strong>Visited:</strong> {{review.visitedTo | date}}</div>
  }
  <div><strong>Reviewed: </strong>{{review.createdOn | date}}</div>
</review-display>
